export const catalogsStates = {
	edicion: 'en_edicion',
	ejecucion: 'en_ejecucion',
	negociacion: 'negociacion',
	revision: 'revision',
}
